import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';

@Component({
  selector: 'app-slider-menu',
  templateUrl: './slider-menu.component.html',
  styleUrls: ['./slider-menu.component.scss']
})
export class SliderMenuComponent implements OnInit {

  menuUsers = [];
  user: any;
  userName: string;

  constructor(private firebaseAuthService: FirebaseAuthService, public router: Router) {
    this.menuUsers = [
      {
        title: 'Resumen',
        icon: 'summarize',
        url: 'profile'
      },
      // {
      //   title: 'Facturación',
      //   icon: 'receipt_long',
      //   url: ''
      // },
      {
        title: 'Mis referidos',
        icon: 'connect_without_contact',
        url: 'referred'
      },
      {
        title: 'Compras',
        icon: 'inventory',
        url: 'compras'
      },
      {
        title: 'Configuración',
        icon: 'settings_suggest',
        url: '',
        subMenu: [
          {
            title: 'Editar Perfil',
            icon: 'manage_accounts',
            url: 'edit-profile',
          },
          {
            title: 'Cambiar Contraseña',
            icon: 'vpn_key',
            url: 'change-password',
          }
        ]
      }
    ];

    // this.userName  = this.firebaseAuthService;
  }

  ngOnInit(): void {
  }

  endSession(): void{
    localStorage.clear();
    this.firebaseAuthService.logout();
  }

  goToOpt(url){
    this.router.navigate([{outlets: {primary: url ,sidebar: url}}]);
  }

}
